// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__M4ttJ","content":"Layout_content__CuzQZ"};